/**
 * Product Gallery JS - Matches React ProductDetailPage.tsx
 * Thumbnail selection, image zoom on hover/mouse move, keyboard/touch support
 */
(function () {
  'use strict';

  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  const mainContainer = gallery.querySelector('[data-gallery-main]');
  const slides = gallery.querySelectorAll('[data-gallery-slide]');
  const thumbs = gallery.querySelectorAll('[data-thumb-index]');
  const zoomHint = gallery.querySelector('[data-zoom-hint]');

  if (slides.length === 0) return;

  let current = 0;

  function goToSlide(index) {
    slides[current].classList.remove('is-active');
    if (thumbs[current]) thumbs[current].classList.remove('is-active');

    current = index;

    slides[current].classList.add('is-active');
    if (thumbs[current]) thumbs[current].classList.add('is-active');
  }

  /* ---- Thumbnail Click ---- */
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      goToSlide(parseInt(thumb.dataset.thumbIndex, 10));
    });
  });

  /* ---- Image Zoom ---- */
  slides.forEach(function (slide) {
    const img = slide.querySelector('.product-gallery__image');
    if (!img) return;

    slide.addEventListener('mouseenter', function () {
      img.style.transform = 'scale(2)';
      if (zoomHint) zoomHint.style.opacity = '0';
    });

    slide.addEventListener('mouseleave', function () {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = '50% 50%';
      if (zoomHint) zoomHint.style.opacity = '1';
    });

    slide.addEventListener('mousemove', function (e) {
      const rect = slide.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });
  });

  /* ---- Keyboard Nav ---- */
  gallery.setAttribute('tabindex', '0');
  gallery.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight' && current < slides.length - 1) {
      goToSlide(current + 1);
      e.preventDefault();
    }
    if (e.key === 'ArrowLeft' && current > 0) {
      goToSlide(current - 1);
      e.preventDefault();
    }
  });

  /* ---- Product Accordions ---- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const accordion = trigger.closest('[data-accordion]');
      if (!accordion) return;
      const content = accordion.querySelector('[data-accordion-content]');
      if (!content) return;

      const isOpen = accordion.classList.contains('is-open');

      if (isOpen) {
        accordion.classList.remove('is-open');
        content.style.display = 'none';
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        accordion.classList.add('is-open');
        content.style.display = '';
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---- Quantity Controls (shared with cart) ---- */
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('[data-quantity-wrapper]').querySelector('[data-qty-input]');
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val - 1);
      }
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('[data-quantity-wrapper]').querySelector('[data-qty-input]');
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      }
    });
  });

  /* ---- Variant Selector ---- */
  const variantSelects = document.querySelectorAll('[data-option-index]');
  const variantIdInput = document.querySelector('[data-variant-id]');

  if (variantSelects.length > 0 && window.__productJSON) {
    variantSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        const options = [];
        variantSelects.forEach(function (s) { options.push(s.value); });

        const variant = window.__productJSON.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === options[i]; });
        });

        if (variant) {
          if (variantIdInput) variantIdInput.value = variant.id;

          // Update price display
          const priceEl = document.querySelector('.product-info__price');
          if (priceEl && window.Shopify && window.Shopify.formatMoney) {
            priceEl.textContent = window.Shopify.formatMoney(variant.price);
          }

          // Update availability
          const atcBtn = document.querySelector('[data-add-to-cart]');
          if (atcBtn) {
            atcBtn.disabled = !variant.available;
            atcBtn.querySelector('span, svg + *') && (atcBtn.lastChild.textContent = variant.available ? 'Add to Cart' : 'Sold Out');
          }

          // Update URL
          const url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      });
    });
  }

  /* ---- AJAX Add to Cart ---- */
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const atcBtn = productForm.querySelector('[data-add-to-cart]');
      if (atcBtn) atcBtn.disabled = true;

      const formData = new FormData(productForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          // Update cart count
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          // Open cart drawer
          var drawer = document.querySelector('[data-cart-drawer]');
          if (drawer) {
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          }
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
        })
        .finally(function () {
          if (atcBtn) atcBtn.disabled = false;
        });
    });
  }
})();

document.addEventListener("DOMContentLoaded", function(){

  const slides = document.querySelectorAll("[data-gallery-slide]");
  const prev = document.querySelector("[data-gallery-prev]");
  const next = document.querySelector("[data-gallery-next]");
  const gallery = document.querySelector("[data-product-gallery]");

  if(!slides.length) return;

  let current = 0;
  let startX = 0;
  let endX = 0;

  function showSlide(index){
    slides.forEach(s => s.classList.remove("is-active"));
    slides[index].classList.add("is-active");
  }

  function nextSlide(){
    current = (current + 1) % slides.length;
    showSlide(current);
  }

  function prevSlide(){
    current = (current - 1 + slides.length) % slides.length;
    showSlide(current);
  }

  if(prev){
    prev.addEventListener("click", prevSlide);
  }

  if(next){
    next.addEventListener("click", nextSlide);
  }

  /* MOBILE SWIPE SUPPORT */

  if(gallery){

    gallery.addEventListener("touchstart", function(e){
      startX = e.touches[0].clientX;
    });

    gallery.addEventListener("touchend", function(e){

      endX = e.changedTouches[0].clientX;

      if(startX - endX > 50){
        nextSlide();
      }

      if(endX - startX > 50){
        prevSlide();
      }

    });

  }

});

document.addEventListener("DOMContentLoaded", function(){

  const images = document.querySelectorAll(".product-gallery__image");
  const lightbox = document.querySelector("[data-lightbox]");
  const lightboxImg = document.querySelector(".lightbox-image");
  const closeBtn = document.querySelector(".lightbox-close");

  images.forEach(img => {

    img.addEventListener("click", function(){

      if(window.innerWidth < 768){

        lightboxImg.src = img.dataset.full || img.src;
        lightbox.classList.add("active");

        document.body.style.overflow = "hidden";

      }

    });

  });

  closeBtn.addEventListener("click", function(){

    lightbox.classList.remove("active");
    document.body.style.overflow = "";

  });

});